import React, { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { FaRegCopy } from 'react-icons/fa'
import useCopy from 'use-copy'
import { useToasts } from 'react-toast-notifications'

import MainModal from '../../../../components/dashboard/modal/MainModal'
import InfoModalHead from '../../../../components/dashboard/modal/InfoModalHead'
import Flex from '../../../../components/layouts/Flex'
import DashboardInput from '../../../../components/dashboard/DashboardInput'

import {
  setModal,
  setNotification,
  setLoading,
} from '../../../../store/actions/clientActions'

import axiosInstance from '../../../../services/config/AxiosIntance'

import { applicantSiteUrl } from '../../../../constant/constant'

const GenerateVacancyRequest = () => {
  const dispatch = useDispatch()

  const [vacancyRequestUrl, setVacancyRequestUrl] = useState('')
  const [, copy, setCopied] = useCopy(vacancyRequestUrl)
  const { addToast } = useToasts()

  const loading = useSelector(
    (state) => state.clients.loading.generateVacancyRequest
  )

  useEffect(() => handleGenerateVacancyRequestURL(), [])

  const handleCopyUrl = () => {
    copy()

    const copySuccess = `Successfully copied vacancy URL`

    addToast(copySuccess, { appearance: 'info' })

    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  const handleGenerateVacancyRequestURL = () => {
    axiosInstance
      .post('/token')
      .then((response) => {
        const token = response?.data?.resp?.token
        const url = `${applicantSiteUrl}/vacancy-request/${token}`
        setVacancyRequestUrl(url)
      })
      .catch((err) => {
        dispatch(setNotification('error', err?.response?.data?.message))
      })
      .finally(() => {
        dispatch(setLoading({ name: 'generateVacancyRequest', value: false }))
      })
  }

  const handleClose = () => dispatch(setModal([]))

  return (
    <MainModal
      buttonText="Generate URL"
      loading={loading}
      onClick={handleGenerateVacancyRequestURL}
      onClose={handleClose}
      header={<InfoModalHead title="Generate Vacancy Request" />}
    >
      {/*  */}
      <Flex direction="row" items="center">
        <DashboardInput
          readOnly
          label="Vacancy Request URL"
          placeholder=""
          name="certification"
          type="text"
          height="2.5rem"
          value={vacancyRequestUrl}
        />
        <StyledCopy onClick={handleCopyUrl}>
          <FaRegCopy className="icon" />
        </StyledCopy>
      </Flex>
    </MainModal>
  )
}

const StyledCopy = styled.div`
  height: 2.5rem;
  margin-top: 6px;
  height: 2.5rem;
  background: rgb(255, 255, 255);
  outline: none;
  border: 1px solid rgb(174, 179, 201);
  border-left: none;
  padding: 0.5rem;
  font-size: 0.75rem;
  color: rgb(14, 19, 36);
  font-weight: 300;
  cursor: pointer;

  .icon {
    font-size: 1.5rem;
    color: #1a1a1a;
  }
`

export default GenerateVacancyRequest
